
import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ip } from '../../config';
import SingleAlumniCard from './SingleAlumniCard';
import SpinLoader from '../Miscel/SpinLoader';
import NoEventFound from './Comps/NoEventFound';
import * as React from 'react';



const SingleAlumni = () => {
  const { id } = useParams();
  const [cardInfo, setCardInfo] = useState();
  const [reload,setRelaod] = useState(false);

  useEffect(() => {
    fetch(ip + "/events/" + id).
      then(res => {
        if (res.status !== 200) throw new Error("Event not found")
        return res.json();
      }).then(data => {
        setCardInfo(data);        
        setTimeout(() => {
          document.getElementById("spinloader").classList.add("invisible")
        }, 700);
      }
      );

  }, [reload]);


  return (
    <div className="container">
      <SpinLoader />
      {(cardInfo === undefined || cardInfo===null) && <NoEventFound />}
      {cardInfo && <SingleAlumniCard cardInfo={cardInfo}  setRelaod={setRelaod}/>}
    </div>

  );
}

export default SingleAlumni;